import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import DpeActivator from '../components/dpe/dpe-activator/DpeActivator';
import { authActions } from '../redux/authentication/actions/AuthActions.creators';
import { makeGetAuthStatus } from '../redux/authentication/selectors/AuthSelectors';
import { makeGetAuthFormStep } from '../redux/authForm/selectors/AuthFormSelectors';
const DpeActivatorContainer = ({ getUserAuthState, authFormStep, digitalPartner, logoUrl, displayAs, notAuthLabel, authLabel, isAuthenticated, }) => {
    useEffect(() => {
        getUserAuthState();
    }, []);
    return (_jsx(DpeActivator, { authFormStep: authFormStep, digitalPartner: digitalPartner, logoUrl: logoUrl, displayAs: displayAs, notAuthLabel: notAuthLabel, authLabel: authLabel, isAuthenticated: isAuthenticated }));
};
const makeMapStateToProps = () => {
    const getAuthStatus = makeGetAuthStatus();
    const getAuthFormStep = makeGetAuthFormStep();
    return (state) => ({
        isAuthenticated: getAuthStatus(state),
        authFormStep: getAuthFormStep(state),
    });
};
const mapDispatchToProps = { getUserAuthState: authActions.getUserAuthState };
export default connect(makeMapStateToProps, mapDispatchToProps)(DpeActivatorContainer);
